import { render, staticRenderFns } from "./status.vue?vue&type=template&id=5036518c&scoped=true"
import script from "./status.vue?vue&type=script&lang=js"
export * from "./status.vue?vue&type=script&lang=js"
import style0 from "./status.vue?vue&type=style&index=0&id=5036518c&prod&lang=scss"
import style1 from "./status.vue?vue&type=style&index=1&id=5036518c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5036518c",
  null
  
)

export default component.exports